
import { colorToTransparantize } from "@/utils/helpers.js";

export default {
  name: "Hexagon",
  props: {
    color: {
      type: String,
      default: colorToTransparantize('#328FE5', .75)
    }
  }
}
